import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap'
import DownloadBrochureAgilusFile from '../assets/images/Agilus_Brochure.pdf'
import DownloadBrochureVelocisFile from '../assets/images/Velocis _Brochure.pdf'
import axios from 'axios'
import swal from 'sweetalert'
import { checkStringContains, baseURL } from './domainValidator'

const DownloadBrochure =  forwardRef(({...props}, ref) => {


  const [emailDomainData, setEmailDomainData] = useState([])

  const [modal, setModal] = useState()

  const [cname, setCname] = useState("")
  const [title, setTitle] = useState("")
 
  const [name, setName] = useState(null)
  // const [domain, setDomain] = useState(null)
  const [workMail, setWorkmail] = useState(null)
  const [subject, setSubject] = useState(null)
  // const [dateTime, setDateTime] = useState(null)

  const [nameError, setNameError] = useState(null)
  // const [domainError, setDomainError] = useState(null)
  const [workMailError, setWorkmailError] = useState(null)
  const [subjectError, setSubjectError] = useState(null)
  // const [dateTimeError, setDateTimeError] = useState(null)

  const [disableSubmitNow, setDisableSubmitNow] = useState(false)

  const [phoneNo, setPhoneNo] = useState('')
  const [phoneNoError, setPhoneNoError] = useState('')

  const [fileType, setFileType] = useState('')
      
  const openModal=()=>{
      setModal(!modal)
      setName('')

      setWorkmail('')
      setSubject('')
      setPhoneNo('')

      setNameError('')

      setWorkmailError('')
      setSubjectError('')
  }


  const cnameFun = (data) => {
    let {title, cname, fileType} = data

    setCname(cname)
    setTitle(title)
    setFileType(fileType)
  } 

  const getDomainNameData=()=>{
    const headers = {headers: {'Accept': 'application/json', 'Content-Type': 'application/json', 'X-Frame-Options': 'DENY'}};
    fetch(`${baseURL}/getEmailDomains`, headers)
        .then(res => res.json())
        .then(json =>{
            setEmailDomainData(json.data.email_domains)
        }).catch((error) => {
          console.error("Error fetching data:", error);
      });
  }

  const validation=()=>{
    const nameFieldRegex = /^[^\s].+[a-zA-Z]+[a-zA-Z]+$/;
    const mumberFieldRegex =  /^(?!00)[0-9]*$/ // /^(\+\d{1,3}[- ]?)?\d{10,13}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const domainNameRegex = /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/;
      let validated = true;
      if (!name) {
          const nameError = "Please Enter your Full Name";
          setNameError(nameError)
          validated = false;
        } else {
          if (!nameFieldRegex.test(name)) {
            const nameError = "Please Enter your Valid Full Name";
            setNameError(nameError)
            validated = false;
          } else {
            const nameError = "";
            setNameError(nameError)
          }
        }
      // if (!domain) {
      //     const domainError = "Please Enter your  Domain";
      //     setDomainError(domainError)
      //     validated = false;
      //   } else {
      //     if (!domainNameRegex.test(domain)) {
      //       const domainError = "Please Enter valid  Domain";
      //       setDomainError(domainError)
      //       validated = false;
      //     } else {
      //       const domainError = "";
      //       setDomainError(domainError)
      //     }
      //   }
      if (!phoneNo) {
        const phoneNoError = "";
        setPhoneNoError(phoneNoError)
      } else {
        if (!mumberFieldRegex.test(phoneNo)) {
          const phoneNoError = "Please Enter Valid Number";
          setPhoneNoError(phoneNoError)
          validated = false;
        } else {
          const phoneNoError = "";
          setPhoneNoError(phoneNoError)
        }
      }
      if (!workMail) {
          const workMailError = "Please Enter your Official Email ID";
          setWorkmailError(workMailError)
          validated = false;
        } else {
          if (!emailRegex.test(workMail)) {
            const workMailError = "Please Enter valid Official Email ID";
            setWorkmailError(workMailError)
            validated = false;
          } else {
            let temptValidator= checkStringContains(emailDomainData, workMail)
            if (temptValidator === false) {
              const workMailError = "Please Enter valid Workmail Id";
              setWorkmailError(workMailError)
              validated = false;
            } else {
              const workMailError = "";
              setWorkmailError(workMailError)
            }
          }
        }
      // if (!subject) {
      //     const subjectError = "Please Enter your  Subject";
      //     setSubjectError(subjectError)
      //     validated = false;
      //   } else {
      //     const subjectError = "";
      //     setSubjectError(subjectError)
      //   }
      // if (!dateTime) {
      //     const dateTimeError = "Please Enter your Demo Datetime";
      //     setDateTimeError(dateTimeError)
      //     validated = false;
      //   } else {
      //     const dateTimeError = "";
      //     setDateTimeError(dateTimeError)
      //   }
        return validated;
  }
  

  const handleChange=(e)=>{
      const name = e.target.name;
      const value = e.target.value;

      if(name === 'name'){
          setName(value)
      }
      // if(name === 'domain'){
      //     setDomain(value)
      // }
      if(name === 'workMail'){
          setWorkmail(value)
      }
      if(name === 'subject'){
          setSubject(value)
      }

      if(name == 'phoneNo'){
        setPhoneNo(value)
      }
      // if(name === 'dateTime'){
      //     setDateTime(value)
      // }
  }

const handleSubmit=()=>{

  const valid = validation()

  if(valid){
    setDisableSubmitNow(true)

        axios.post(`${baseURL}/getBrochure`, {
          name : name, 
          // domain : domain, 
          mail : workMail, 
          // date : dateTime, 
          downloadFor: cname,
           subject : subject,
           phoneNo: phoneNo,
           fileType: fileType
        })
        .then(function (response) {
          setModal(!modal)
          swal('Success!', `You will shortly receive the link to download in your email.`, 'success')

          setName('')

          setWorkmail('')
          setSubject('')


          setNameError('')

          setWorkmailError('')
          setSubjectError('')
          setDisableSubmitNow(false)
           localStorage.setItem('downloadKey', cname)
        })
        .catch(function (error) {
         
          swal('Error', `something went wrong`, 'error');
          setName('')

          setWorkmail('')
          setSubject('')


          setNameError('')

          setWorkmailError('')
          setSubjectError('')
          setDisableSubmitNow(false)
        })
        .finally(()=>{
          setName('')
          setWorkmail('')
          setSubject('')
          setPhoneNo('')
          setNameError('')
          setWorkmailError('')
          setSubjectError('')
        });
      }
}



useEffect(()=>{
  getDomainNameData()
}, [])

useImperativeHandle(ref, ()=>
(
  {openModal, cnameFun}
)
)

return (
  <>
  {
    title === 'Download Brochure →' ?
    <>
    {/* <button className='btn-cutom-outline mt-2 d-inline-block' onClick={openModal}>Download Brochure →</button> */}
    </>
    :
  <>

    {/* <div onClick={openModal}> {title} </div> */}
  </>    
  }
  
  <Modal isOpen={modal} >
      <ModalHeader toggle={openModal}>Request For Download</ModalHeader>
      <ModalBody>
      <div className='conatct-form-model'>
          <label>Name<span className='text-danger'>*</span></label> {nameError ? <small className='text-danger'>{nameError}</small> : null}
          <input value={name} maxLength={51} onChange={handleChange} className='form-control mb-2' name='name' />
          
          {/* <label>Domain<span className='text-danger'>*</span></label> {domainError ? <small className='text-danger'>{domainError}</small> : null}
          <input value={domain} onChange={handleChange} className='form-control mb-2' name='domain' /> */}

          <label>Download</label>
          <input value={cname} disabled className='form-control mb-2' name='domain' />


          
          <label>Official Email ID<span className='text-danger'>*</span></label> {workMailError ? <small className='text-danger'>{workMailError}</small> : null}
          <input value={workMail} maxLength={100} onChange={handleChange} className='form-control mb-2' name='workMail' />


          <label>Phone Number</label>{phoneNoError ? <small className='text-danger'>{phoneNoError}</small> : null}
          <input value={phoneNo} maxLength={10} onChange={handleChange} className='form-control mb-3' name='phoneNo' />
          
          
          {/* <label>Datetime<span className='text-danger'>*</span></label> {dateTimeError ? <small className='text-danger'>{dateTimeError}</small> : null}
          <input value={dateTime} type='datetime-local' onChange={handleChange} className='form-control mb-2' name='dateTime' /> */}
          
          <label>Message
              {/* <span className='text-danger'>*</span> */}
              </label> 
          {/* {subjectError ? <small className='text-danger'>{subjectError}</small> : null} */}
          <textarea value={subject} onChange={handleChange} className='form-control' name='subject' />
          
          
      </div>
      </ModalBody>
      <ModalFooter>
      <button className='btn-custom d-block w-100 border-0' onClick={handleSubmit} disabled={disableSubmitNow}>Submit</button>
      </ModalFooter>
  </Modal>
  </>
)
}) 



export default DownloadBrochure
